var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-logo"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('img',{attrs:{"src":_vm.resourceUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }